export const TEAM_SQUAD_TABLE_COLUMNS_TO_EXCLUDE = ['currentTeam'];
